// src/bingoLogic.js - (Revised)

export const BINGO_LETTERS = ['B', 'I', 'N', 'G', 'O'];
export const NUMBERS_PER_LETTER = 15;
export const TOTAL_BALLS = 75; // B:1-15, I:16-30, N:31-45, G:46-60, O:61-75

/**
 * Creates and shuffles an array of all possible Bingo ball numbers (1-75).
 * @returns {Array<number>} Shuffled array of numbers 1 to 75.
 */
export const getShuffledBalls = () => {
  const allBalls = Array.from({ length: TOTAL_BALLS }, (_, i) => i + 1);
  // Fisher-Yates (Knuth) Shuffle
  for (let i = allBalls.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [allBalls[i], allBalls[j]] = [allBalls[j], allBalls[i]];
  }
  return allBalls;
};

/**
 * Gets the BINGO letter associated with a ball number.
 * @param {number} ballNumber
 * @returns {string} The letter ('B', 'I', 'N', 'G', 'O')
 */
export const getLetterForBall = (ballNumber) => {
    if (ballNumber < 1 || ballNumber > TOTAL_BALLS) return '';
    const letterIndex = Math.floor((ballNumber - 1) / NUMBERS_PER_LETTER);
    return BINGO_LETTERS[letterIndex];
}